var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { serializeStyles } from "@emotion/serialize";
import { StyleSheet } from "@emotion/sheet";
import { compile, middleware, rulesheet, serialize, stringify } from "stylis";
export function injectGlobal() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = serializeStyles.apply(void 0, __spreadArray([], __read(args), false)), name = _a.name, styles = _a.styles;
    var sheet = new StyleSheet({
        key: "global-".concat(name),
        container: document.head,
    });
    var stylis = function (styles) {
        return serialize(compile(styles), middleware([
            stringify,
            rulesheet(function (rule) {
                sheet.insert(rule);
            }),
        ]));
    };
    stylis(styles);
    return function () { return sheet.flush(); };
}
